import { useCallback } from 'react';
import { useApiBase } from '../../base';

export function usePostIdentidadeRefreshToken() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIdentidadeRefreshToken = useCallback(
        (tokenAtual: string) =>
            invocarApi({
                url: `v2/identidade/refresh-token`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: `"${tokenAtual}"`,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIdentidadeRefreshToken,
    };
}
